import { Article, Heading, P } from '@slal/ui/typography';
import { DocumentList } from '~/components';
import { DisclaimerAndDocumentsWrapper, ProductDisclaimerSection, ProductDocumentSection } from './styles';

export const ProductFeatures = () => {
    const id = 'product-documents-title';

    return (
        <Article aria-label="Product features">
            <DisclaimerAndDocumentsWrapper>
                <ProductDisclaimerSection>
                    <P>
                        This application is for the Active Money Personal Pension provided by Phoenix Life Limited,
                        trading as Standard Life.
                    </P>
                </ProductDisclaimerSection>
                <ProductDocumentSection>
                    <Heading level={3} id={id}>
                        Important documents
                    </Heading>
                    <DocumentList
                        aria-labelledby={id}
                        documents={[
                            {
                                children: 'Key features document',
                                href: 'https://lib.standardlife.com/library/uk/ampp17d.pdf',
                            },
                            {
                                children: 'Fund choices',
                                href: 'https://lib.standardlife.com/library/uk/ampp5a.pdf',
                            },
                            {
                                children: 'Key features illustration',
                                href: 'https://library.standardlife.co.uk/ampp107.pdf',
                            },
                        ]}
                    />
                </ProductDocumentSection>
            </DisclaimerAndDocumentsWrapper>
        </Article>
    );
};
